import { Component } from '@angular/core';
import { CommonService } from '../../../services/common/common.service';
import { ToasterService, UserService } from '../../../services/common';
import { VaultService } from '../../services/vault.service';
import { SalesService } from '../../../main-layout/sales';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-vault-pay',
  templateUrl: './vault-pay.component.html',
  styleUrl: './vault-pay.component.scss'
})


export class VaultPayComponent {
  vaultPayList: any[] = [];
  selectedExportData: any[] = [];
  vaultSupportData: any = {}
  showaddUpdateModal: boolean = false;
  isChildCalled: boolean = false;
  context: string = ''

  private destroy$ = new Subject<void>();

  constructor(public commonService: CommonService, private toasterService: ToasterService, private vaultService: VaultService,
    public saleservice: SalesService, private userService: UserService
  ) { }

  ngOnInit(): void {
    this.refreshEntites();
    this.getVaultPayList();
  }

  refreshEntites() {
    this.getBasicUserList()
  }

  /**
   * Fetches the list of vault payments.
   */
  getVaultPayList() {
    this.vaultService.filterVaultPayList().subscribe(res => {
      if (res?.result?.length > 0) {
        this.vaultPayList = res.result.map((item: any) => {
          return {
            ...item,
            Sender: item?.accountDetails?.firstName + ' ' + item?.accountDetails?.lastName,
          };
        });
      }
    });
  }

  getBasicUserList() {
    this.userService.getFilterBasicUser({ isactive: true }).subscribe((res: any) => {
      if (res) {
        this.vaultSupportData.usersList = res?.result?.map((item: any) => {
          return {
            ...item,
            name: item?.initialDetails?.name + '. ' + item?.firstName + ' ' + item?.lastName,
          }
        });
      }
    });
  }

  closePaymentDialogue() {
    this.showaddUpdateModal = false;
    this.isChildCalled = false;
  }

  changeAddUpdateModelState(event: any) {
    this.context = event.context;

    this.showaddUpdateModal = event.showaddUpdateModal;
  }

  ngOnDestroy(): void {
    // Signal completion to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
